module.exports = __webpack_public_path__ + "static/media/clock.60589389.svg";